/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-16 17:40:09
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-17 12:11:40
 */
import React from 'react';
import { IconFont } from '@features/common/Icon';
import './SFCFullModel.less';

export interface ISFCFullModelProps {
  children?: React.ReactNode;
  onClose: () => void;
  title: string;
  className?: string;
  titleTip?: React.ReactNode;
}
type Props = ISFCFullModelProps;

export function SFCFullModel(props: Readonly<Props>) {
  const { children, onClose, title, className, titleTip } = props;

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <div className={`common-presenter k-common-full-model ${className}`}>
      <div className="full-model__top">
        <div>
          {title}
          {titleTip}
        </div>
        <IconFont type="icon-close" className="full-model__close" onClick={handleClose} />
      </div>
      {children}
    </div>
  );
}

export default SFCFullModel;
